import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { DeviceProvider } from './DeviceContext'
import { BestenlisteScreen } from './screens/Bestenliste'
import { DuellScreen } from './screens/Duell'
import { HomeScreen } from './screens/Home'
import { KalibrierenScreen } from './screens/Kalibrieren'
import { LangstreckeScreen } from './screens/Langstrecke'
import { SprintScreen } from './screens/Sprint'
import { SprungScreen } from './screens/Sprung'

export function App() {
  return (
    <BrowserRouter>
      <DeviceProvider>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/langstrecke" element={<LangstreckeScreen />} />
          <Route path="/sprung" element={<SprungScreen />} />
          <Route path="/sprint" element={<SprintScreen />} />
          <Route path="/bestenliste" element={<BestenlisteScreen />} />
          <Route path="/kalibrieren" element={<KalibrierenScreen />} />
          <Route path="/duell/:code" element={<DuellScreen />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </DeviceProvider>
    </BrowserRouter>
  )
}
